import '../../../modules/authstate-context';
import '../../../modules/close-app-button';
import {pages, adjustTokens, cookies, privacyPolicySections} from '../../../modules/constants-enumerate';
import '../../../modules/dd-menu';
import '../../../modules/dd-menu-button';
import '../../../modules/link-to-element';
import '../../../modules/logout-button';
import '../../../modules/main-layout';
import '../../../modules/picture';
import {imageConfig} from './__config/images';
import './modules/academy-video';
import './modules/carousel';
import './modules/lazy-load-bg';
import './modules/home-header';
import './modules/home-footer';
import './modules/prospect-reg-form';
import './modules/top-prospect-reg-form-mobile';
import Cookies from 'js-cookie';

const isRegionCalifornia = Cookies.get(cookies.REGION) === 'CA';

export const template = (ctx, html) => html`
  <main-layout>
    <home-header prevent-redirect id="home-header" role="banner" slot="page-header">
    </home-header>

    <main id="page-content" slot="page-content" role="main">
      <div id="dd-menu-container">
        <dd-menu-button id="dd-menu-button" class="dd-focus tab-outline-yellow" tabindex="0" menu-color="${ctx.ddMenuColor}" slot="left"></dd-menu-button>
        <dd-menu slot="left">
          <link-to dom-scope="1x+/JMra" class="link enteractive" href="${pages.LOGIN}" tab-outline-blue><span>Log In</span></link-to>
          <link-to dom-scope="0BSCZw8D" class="link enteractive" href="${pages.SUBSCRIPTION}" tab-outline-blue><span>Sign Up</span></link-to>
          <link-to dom-scope="cK2EGWm1" class="link enteractive" href="${pages.SUBSCRIPTION}" tab-outline-blue><span>Try It Free</span></link-to>
          <link-to dom-scope="cvvZcIkj" class="link enteractive" href="${pages.TANDC}" target="_blank" rel="noopener noreferrer" tab-outline-blue><span>Terms &amp; Conditions</span></link-to>
          <link-to dom-scope="Wtpg6Lr8" class="link enteractive" href="${pages.PRIVACY_POLICY}" target="_blank" rel="noopener noreferrer" tab-outline-blue><span>Privacy Policy</span></link-to>
          <link-to dom-scope="gxwZagq6" class="link enteractive reset-dd-focus" href="${pages.CUSTOMER_SUPPORT}" target="_blank" rel="noopener noreferrer" tab-outline-blue><span>Customer Support</span></link-to>
          <authstate-context show-when-loggedin>
            <logout-button dom-scope="6qfEs65T" class="link reset-dd-focus enteractive" tabindex="0">Log Out</logout-button>
          </authstate-context>
        </dd-menu>
      </div>

      <academy-video id="academy-video"></academy-video>
      <section id="top-banner-container" role="heading" aria-level="1" class="page-section">
        <a dom-scope="d04ZyUyS" id="skip-navigation-link" class="enteractive" href="${ctx.skipNavTarget === ctx.learnMoreButton ? '#learn-more-link' : '#top-prospect-reg-email'}" @click="${(e) => ctx.skipNavTo(e)}" slot="skip-navigation" aria-label="Skip to Main Content" tabindex="0"><div class="montserrat">Skip Navigation</div></a>
        <div id="initial-header-content">
          <div class="nav-header-button-row neuton">
            <link-to dom-scope="cRIguNRW" id="login-button" class="page-link" href="${pages.LOGIN}" aria-label="Log In to Adventure Academy" tab-outline-blue>
              <aofl-picture>
                ${imageConfig.loginButton.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="nav-header-links" src="${imageConfig.loginButton[4].src}" width="121" height="39" alt="Log In to Adventure Academy"></aofl-img>
              </aofl-picture>
            </link-to>
            <link-to dom-scope="mn4uRWdj" id="signup-button" class="page-link" href="${pages.SUBSCRIPTION}" aria-label="Sign Up for Adventure Academy" tab-outline-blue>
              <aofl-picture>
                ${imageConfig.signupButton.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="nav-header-links" src="${imageConfig.signupButton[3].src}" width="151" height="39" alt="Sign Up for Adventure Academy"></aofl-img>
              </aofl-picture>
            </link-to>
          </div>
        </div>
        <div id="subscription-offers-container" class="new-u-m-hide">
          <aofl-picture>
            <link-to dom-scope="8/3l+f2k" id="annual-offer-link" class="subscription-offer-img" href="${pages.SUBSCRIPTION_ANNUAL}" aria-label="Special offer! Learn how to save 49% with an annual subscription" tab-outline-blue>
              <aofl-picture>
                ${imageConfig.annualOffer.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                  <aofl-img src="${imageConfig.annualOffer[7].src}" width="339" height="349" alt="Special Offer! Learn how to save 70% off our monthly pricing with an annual subscription of $45 per year until canceled."></aofl-img>
              </aofl-picture>
            </link-to>
          </aofl-picture>

          <aofl-picture>
            ${imageConfig.gameplayTrailerButton.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
              `)}
            <div id="try-it-free-video-banner" class="subscription-offer-img tab-outline-blue enteractive" @click="${()=>ctx.playGameplayVideo()}" tabindex="0">
              <aofl-img id="try-it-free-video-dt" src="${imageConfig.gameplayTrailerButton[7].src}" width="796" height="169" alt="Click to learn more about Adventure Academy. Try it Free for 30 Days then just $12.99 per month until canceled."></aofl-img>
            </div>
          </aofl-picture>
        </div>
      </section>

      <section id="annual-offer-container" class="page-section new-u-m-hide">
        <div class="prospect-box">
          <div>
            <p class="alegreya" id="fmf-text">
              <span class="top">GET YOUR FIRST</span>
              <span class="u-br"></span>
              <span class="bottom">MONTH FREE!</span>
            </p>
            <aofl-picture>
              ${imageConfig.redSwoosh.map((image) => html`
                <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
              `)}
              <aofl-img id="red-swoosh" src="${imageConfig.redSwoosh[8].src}" width="204" height="28" alt=""></aofl-img>
            </aofl-picture>
            <p id="until-canceled-top-text" class="montserrat">then just $12.99/mo., until canceled</p>
          </div>
          ${!Cookies.get(cookies.ELOG) ?
            html`<p class="montserrat" id="enter-email">ENTER YOUR EMAIL ADDRESS BELOW TO BEGIN:</p>` :''}
          <prospect-reg-form dom-scope="ZevWTwZs" id="top-prospect-reg" adjust-token="${adjustTokens.MINIREG_TOP}" class="prospect-reg enteractive"></prospect-reg-form>
          <div id="min-device-req-container">
            <div dom-scope="Qt1DfUWM" id="min-device-req" class="montserrat tab-outline-blue enteractive ${Boolean(Cookies.get(cookies.ELOG))}" role="button" @click="${(e) => ctx.showMinDeviceReqModal(e)}" aria-label="Learn about minimum device requirements" tabindex="0">Minimum Device Requirements</div>
          </div>
        </div>
      </section>

      <section class="new-u-hide" id="offer-container">
        <div id="blue-ribbon-container">
          <p id="blue-ribbon-text-top" class="montserrat">FROM THE CREATORS OF ABCmouse</p>
          <aofl-picture>
            ${imageConfig.blueRibbonTop.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
              `)}
            <aofl-img id="blue-ribbon-top" src="${imageConfig.blueRibbonTop[3].src}" height="219" width="768" alt=""></aofl-img>
          </aofl-picture>
          <p id="blue-ribbon-text-bottom" class="montserrat" aria-hidden="true">FOR KIDS 8-13</p>
          <p class="ghost">FOR KIDS 8 through 13</p>
        </div>

        <aofl-picture>
          ${imageConfig.tryItFreeVideo.map((image) => html`
            <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
          <div id="try-it-free-video-click" @click="${()=>ctx.playGameplayVideo()}">
            <aofl-img id="try-it-free-video-mb" class="enteractive tab-outline-blue" src="${imageConfig.tryItFreeVideo[3].src}" height="219" width="768" alt="Click to learn more about Adventure Academy. Try it Free for 30 Days then just $12.99 per month until canceled." tabindex="0"></aofl-img>
          </div>
        </aofl-picture>
        <aofl-picture>
          ${imageConfig.annualSpecialOffer.map((image) => html`
            <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
          `)}
          <aofl-img id="annual-offer-special-offer" src="${imageConfig.annualSpecialOffer[3].src}" width="720" height="411" alt="annual subscription special offer learn more link"></aofl-img>
          <link-to dom-scope="8/3l+f2k" id="annual-offer-special-offer-link-to" href="${pages.SUBSCRIPTION_ANNUAL}" aria-label="Special offer! Learn how to save 60% with an annual subscription" tab-outline-blue>
            <aofl-picture>
              ${imageConfig.learnMoreButton.map((image) => html`
                <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
              `)}
                <aofl-img id="annual-offer-learn-more-mobile" src="${imageConfig.learnMoreButton[8].src}" width="296" height="121" alt="Click to learn how to get your first month free then just $12.99 per month until canceled."></aofl-img>
            </aofl-picture>
          </link-to>
        </aofl-picture>

        <aofl-picture>
          <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamOneSmall[0].src}" height="61" width="768"></aofl-source>
          <aofl-img id="quotes-bottom-woodbeam-offer" src="${imageConfig.woodbeamOne[0].src}" height="189" width="2393" alt=""></aofl-img>
        </aofl-picture>
      </section>

      <section id="quotes-container" class="page-section quotes bg1">
        <aofl-picture>
          <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamOneSmall[0].src}" height="61" width="768"></aofl-source>
          <aofl-img id="quotes-top-woodbeam" src="${imageConfig.woodbeamOne[0].src}" height="189" width="2393" alt=""></aofl-img>
        </aofl-picture>
        <div class="quotes-wrapper">
          <div class="column" id="first-quote">
          <blockquote>
            <p class="quote montserrat quote-text">"Adventure Academy is an <span class="u-br"></span>educational MMO teachers <span class="u-br"></span>and students will love."</p>
            <cite class="montserrat quote-text citation">&mdash;Gameinformer</cite>
          </blockquote>
          </div>
          <div class="column" id="second-quote">
          <blockquote>
            <p class="quote montserrat quote-text">“Adventure Academy is this <span class="u-br"></span>amazing world that any kid <span class="u-br"></span>would love to be a part of!”</p>
            <cite class="montserrat quote-text citation">&mdash;Mother of a 7-year-old</cite>
          </blockquote>
          </div>
          <div class="column" id="third-quote">
          <blockquote>
            <p class="quote montserrat quote-text">“Gaming meets school in <span class="u-br"></span>Adventure Academy.”</p>
            <cite class="montserrat quote-text citation">&mdash;USA Today</cite>
          </blockquote>
          </div>
        </div>
        <aofl-picture>
          <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamOneSmall[0].src}" height="61" width="768"></aofl-source>
          <aofl-img id="quotes-bottom-woodbeam" src="${imageConfig.woodbeamOne[0].src}" height="189" width="2393" alt=""></aofl-img>
        </aofl-picture>
      </section>

      <section class="new-u-hide" id="top-prospect-reg-form-mobile-container">
        <aofl-picture>
          ${imageConfig.topRegBox.map((image) => html`
            <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
          <aofl-img id="top-reg-box-mobile" src="${imageConfig.topRegBox[3].src}" width="768" height="396" alt=""></aofl-img>
        </aofl-picture>

        <p id="until-canceled-mobile-text" class="alegreya">then just $12.99/mo., until canceled</p>
        ${!Cookies.get(cookies.ELOG) ? html`<p class="montserrat" id="top-reg-enter-email">ENTER YOUR EMAIL ADDRESS BELOW TO BEGIN:</p>` : ''}
        <top-prospect-reg-form-mobile dom-scope="pH/Caq4u" id="top-prospect-reg" adjust-token="${adjustTokens.MINIREG_TOP}" class="prospect-reg enteractive"></top-prospect-reg-form-mobile>
        <aofl-picture>
          <aofl-img id="top-prospect-reg-form-woodbeam-bottom" src="${imageConfig.woodbeamOneSmall[0].src}" height="56" width="768" alt=""></aofl-img>
        </aofl-picture>
      </section>

      <section id="subjects-container" class="page-section parallax bg1">
        <h4 id="subjects-header" class="section-title neuton">DISCOVER KNOWLEDGE, QUESTS & ADVENTURE!</h4>
        <article id="language-arts-container" class="subject-container">
          <aofl-picture>
            ${imageConfig.languageArts.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img class="subject-banner-img" src="${imageConfig.languageArts[8].src}" height="1384" width="2221" alt=""></aofl-img>
          </aofl-picture>
          <div class="subject-content">
            <h2 class="subject-header neuton">LANGUAGE ARTS</h2>
            <p class="subject-summary montserrat">Immerse yourself in our extensive curriculum to gain essential skills in reading, writing, and language development.</p>
            <ul class="subject-bullets montserrat">
              <li>Main idea and key details</li>
              <li>Comprehension</li>
              <li>Writing</li>
              <li>Spelling & much more</li>
            </ul>
            <aofl-img class="subject-icon" src="${imageConfig.jewelLanguageArts[0].src}" height="208" width="208" alt=""></aofl-img>
          </div>
        </article>
        <article id="math-container" class="subject-container">
          <aofl-picture>
            ${imageConfig.math.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img class="subject-banner-img" src="${imageConfig.math[8].src}" height="1060" width="2085" alt=""></aofl-img>
          </aofl-picture>
          <div class="subject-content">
            <h2 class="subject-header neuton">MATH</h2>
            <p class="subject-summary montserrat">Practice math skills by doing activities in mathematical operations, fractions, word problems, and more!</p>
            <ul class="subject-bullets montserrat">
              <li>Multiplication and division</li>
              <li>Geometry</li>
              <li>Fractions and decimals</li>
              <li>Word problems & much more</li>
            </ul>
            <aofl-img class="subject-icon" src="${imageConfig.jewelMath[0].src}" height="208" width="208" alt=""></aofl-img>
          </div>
        </article>
        <article id="science-container" class="subject-container">
          <aofl-picture>
            ${imageConfig.science.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img class="subject-banner-img" src="${imageConfig.science[8].src}" height="1034" width="2173" alt=""></aofl-img>
          </aofl-picture>
          <div class="subject-content">
            <h2 class="subject-header neuton">SCIENCE</h2>
            <p class="subject-summary montserrat">Guided by your own interests, you can embark on scientific inquiry, no matter what topic you choose.</p>
            <ul class="subject-bullets montserrat">
              <li>Forces & motion</li>
              <li>Environments & ecosystems</li>
              <li>Atoms, molecules, and much more</li>
            </ul>
            <aofl-img class="subject-icon" src="${imageConfig.jewelScience[0].src}" height="208" width="208" alt=""></aofl-img>
          </div>
        </article>
        <article id="social-studies-container" class="subject-container">
          <aofl-picture>
            ${imageConfig.socialStudies.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img class="subject-banner-img" src="${imageConfig.socialStudies[8].src}" height="1316" width="2205" alt=""></aofl-img>
          </aofl-picture>
          <div class="subject-content">
            <h2 class="subject-header neuton">SOCIAL STUDIES</h2>
            <p class="subject-summary montserrat">No matter where&mdash;or when&mdash;you want to go, we can take you there. Learn about:</p>
            <ul class="subject-bullets montserrat">
              <li>Maps and Globes</li>
              <li>History and Geography</li>
              <li>Economics and Innovation</li>
              <li>World Cultures and Traditions</li>
            </ul>
            <aofl-img class="subject-icon" src="${imageConfig.jewelSocialStudies[0].src}" height="208" width="208" alt=""></aofl-img>
          </div>
        </article>
      </section>

      <section id="carousel-container" class="page-section">
        <section id="carousel-inner-container">
          <aofl-picture>
            <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamTwoSmall[0].src}" height="60" width="768"></aofl-source>
            <aofl-img id="carousel-top-woodbeam" src="${imageConfig.woodbeamTwo[0].src}" height="189" width="2400" alt=""></aofl-img>
          </aofl-picture>
          <h2 id="carousel-header" class="section-title neuton">AN EPIC LEARNING ADVENTURE AWAITS!</h2>
          <p id="carousel-summary" class="montserrat">You’re invited to join the ranks of young scholars at Adventure Academy, a fully immersive virtual universe for those seeking knowledge and adventure. Gain access to hundreds of hours of educational activities teaching essential skills in math, language arts, science, social studies, and much more!</p>

          <carousel-element></carousel-element>

          <aofl-picture>
            <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamOneSmall[0].src}" height="61" width="768" alt=""></aofl-source>
            <aofl-img id="carousel-bottom-woodbeam" src="${imageConfig.woodbeamOne[0].src}" height="189" width="2393" alt=""></aofl-img>
          </aofl-picture>
        </section>
      </section>

      <section class="page-section parallax bg2" id="adventure-container">
        <section id="adventure-grid-container">
          <h2 id="adventure-grid-header" class="section-title neuton">CREATE YOUR OWN ADVENTURE</h2>
          <div id="adventure-grid">

            <figure class="adventure-grid-item">
              <aofl-picture>
                ${imageConfig.featureOne.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="feature-img" src="${imageConfig.featureOne[8].src}" height="818" width="1001" alt=""></aofl-img>
              </aofl-picture>
              <figcaption class="grid-item-caption">
                <h3 class="grid-item-title neuton">PLAY WITH FRIENDS</h3>
                <p class="grid-item-summary montserrat">Monitored interactions ensure safety<span class="u-br"></span><span class="u-m-br"></span> and fun with your friends.</p>
              </figcaption>
            </figure>

            <figure class="adventure-grid-item">
              <aofl-picture>
                ${imageConfig.featureTwo.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="feature-img" src="${imageConfig.featureTwo[8].src}" height="818" width="1001" alt=""></aofl-img>
              </aofl-picture>
              <figcaption class="grid-item-caption">
                <h3 class="grid-item-title neuton">CUSTOMIZE YOUR CHARACTER</h3>
                <p class="grid-item-summary montserrat">Level up, unlock access to new zones, fun<span class="u-br"></span><span class="u-m-br"></span> outfits and accessories. Chat with friends!</p>
              </figcaption>
            </figure>

            <figure class="adventure-grid-item">
              <aofl-picture>
                ${imageConfig.featureThree.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="feature-img" src="${imageConfig.featureThree[8].src}" height="818" width="1001" alt=""></aofl-img>
              </aofl-picture>
              <figcaption class="grid-item-caption">
                <h3 class="grid-item-title neuton">PLAYER HOMES</h3>
                <p class="grid-item-summary montserrat">Decorate and customize your<span class="u-br"></span><span class="u-m-br"></span> very own player home.</p>
              </figcaption>
            </figure>

            <figure class="adventure-grid-item">
              <aofl-picture>
                ${imageConfig.featureFour.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                <aofl-img class="feature-img" src="${imageConfig.featureFour[8].src}" height="818" width="1001" alt=""></aofl-img>
              </aofl-picture>
              <figcaption class="grid-item-caption">
                <h3 class="grid-item-title neuton">EXPLORE THE MARKETPLACE</h3>
                <p class="grid-item-summary montserrat">There is much more to discover<span class="u-br"></span><span class="u-m-br"></span> and unlock in the marketplace.</p>
              </figcaption>
            </figure>
          </div>
        </section>

        <section id="device-req-container">
          <aofl-picture>
            <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamTwoSmall[0].src}" height="60" width="768"></aofl-source>
            <aofl-img src="${imageConfig.woodbeamTwo[0].src}" height="189" width="2400" alt=""></aofl-img>
          </aofl-picture>
          <h5 id="device-req-header" class="section-title neuton">AVAILABLE ON ALL PLATFORMS</h5>
          <aofl-picture>
            ${imageConfig.devices.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img id="device-id-img" src="${imageConfig.devices[8].src}" height="696" width="1080" alt=""></aofl-img>
          </aofl-picture>
          <span id="min-device-button" class="neuton">SEE MINIMUM DEVICE REQUIREMENTS <span dom-scope="52aLzMGt" id="min-device-here" class="tab-outline-yellow enteractive" role="button" @click="${(e) => ctx.showMinDeviceReqModal(e)}" aria-label="Learn about minimum device requirements" tabindex="0">HERE</span></span>
        </section>
      </section>

      <section id="bottom-banner-container">
        <div id="bottom-prospect-reg-container">
          <aofl-picture>
            ${imageConfig.miniRegScrollBottom.map((image) => html`
              <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
            `)}
            <aofl-img id="bottom-reg-scroll" src="${imageConfig.miniRegScrollBottom[8].src}" width="1920" height="678" alt=""></aofl-img>
          </aofl-picture>
          <div class="prospect-box">
            <p class="neuton prospect-box-bold">GET YOUR FIRST MONTH FREE!</p>
            <p id="until-canceled-bottom-text" class="bottom alegreya">then just $12.99/mo., until canceled</p>
            <prospect-reg-form dom-scope="kbwrJJbg" id="bottom-prospect-reg" adjust-token="${adjustTokens.MINIREG_TOP}" class="prospect-reg enteractive"></prospect-reg-form>
          </div>
        </div>

        <div id="social-icons-container">
          <h4 class="section-title neuton">STAY CONNECTED</h4>
          <div id="social-icons">
            <link-to dom-scope="r3npWu3I" href="https://www.facebook.com/AdventureAcademyUS/" target="_blank" aria-label="Like us on Facebook" tab-outline-yellow>
              <aofl-img class="social-icon" src="${imageConfig.facebook[0].src}" height="144" width="144" alt="Like us on Facebook"></aofl-img>
            </link-to>
            <link-to dom-scope="4gZW/Wk7" href="https://www.instagram.com/adventureacademy/" target="_blank" aria-label="Follow us on Instagram" tab-outline-yellow>
              <aofl-img class="social-icon" src="${imageConfig.instagram[0].src}" height="144" width="144" alt="Follow us on Instagram"></aofl-img>
            </link-to>
            <link-to dom-scope="R3NCBWiJ" href="https://twitter.com/advacademyus" target="_blank" aria-label="Follow us on Twitter" tab-outline-yellow>
              <aofl-img class="social-icon" src="${imageConfig.twitter[0].src}" height="144" width="144" alt="twitter icon"></aofl-img>
            </link-to>
            <link-to dom-scope="O3iYouRe" href="https://www.youtube.com/adventureacademy" target="_blank" aria-label="Subscribe on YouTube" tab-outline-yellow>
              <aofl-img class="social-icon" src="${imageConfig.youtube[0].src}" height="144" width="144" alt="Subscribe on YouTube"></aofl-img>
            </link-to>
          </div>
        </div>
        <aofl-picture>
          <aofl-source media="(max-width: 768px)" srcset="${imageConfig.woodbeamOneSmall[0].src}" height="61" width="768"></aofl-source>
          <aofl-img id="bottom-banner-woodbeam" src="${imageConfig.woodbeamOne[0].src}" height="189" width="2393" alt=""></aofl-img>
        </aofl-picture>
      </section>
    </main>

    <home-footer slot="page-footer" role="contentinfo">
      <div id="aofl-trademark">
        <span>TM &amp; &copy; 2007 - ${ctx.currentYear} <link-to id="aofl-link" dom-scope="88FQh5gR" href="https://www.ageoflearning.com/" target="_blank" tab-outline-yellow>Age of Learning, Inc.</link-to> Patents Pending</span>
      </div>
      <div id="footer-links">
        <link-to dom-scope="tUpUC/3M" id="tandc" class="link" href="${pages.TANDC}" target="_blank" rel="noopener noreferrer" tab-outline-yellow>Terms &amp; Conditions</link-to>
        <span class="divider" aria-hidden="true">|</span>
        ${isRegionCalifornia ? html`
          <link-to dom-scope="akhbu8Yf" class="link" href="${privacyPolicySections.CALIFORNIA_PRIVACY_RIGHTS}" target="_blank" rel="noopener noreferrer" tab-outline-yellow>Privacy Policy</link-to>
          <span class="divider" aria-hidden="true">|</span>
        `: html`
          <link-to dom-scope="PSoR2vGP" class="link" href="${pages.PRIVACY_POLICY}" target="_blank" rel="noopener noreferrer" tab-outline-yellow>Privacy Policy</link-to>
          <span class="divider" aria-hidden="true">|</span>
        `}
        ${isRegionCalifornia ? html`
          <div dom-scope="A8hPAoh1" class="link marlines-line-break tab-outline-yellow enteractive" role="button" @click="${(e) => ctx.showCookieConsentModal(e)}" tabindex="0">Do Not Sell My Personal Information</div>
          <span class="divider u-m-hide new-u-m-hide" aria-hidden="true">|</span>
          `: ''}
        <link-to dom-scope="wt4jVjXv" class="link" href="${pages.CUSTOMER_SUPPORT}" target="_blank" rel="noopener noreferrer" tab-outline-yellow>Customer Support</link-to>
        <span class="divider" aria-hidden="true">|</span>
        ${!ctx.showAccessibilityLink ? '' : html`
          <link-to dom-scope="FixaYXs9" class="link" href="${pages.ACCESSIBILITY_STATEMENT}" target="_blank" tab-outline-yellow>Accessibility Statement</link-to>
        `}
      </div>
      <div>
        <a dom-scope="9SnaBj1h" class="tab-outline-yellow" href="https://www.kidsafeseal.com/certifiedproducts/adventure_academy.html" target="_blank" rel="noopener noreferrer">
          <aofl-img id="kid-safe-medium" width="130" height="50" border="0" rel="noopener" alt="Adventure Academy is certified by the kidSAFE Seal Program." src="//www.kidsafeseal.com/sealimage/1564216989639546117/adventure_academy_medium_darktm.png"></aofl-img>
        </a>
      </div>
    </home-footer>
  </main-layout>
  <template class="scrolled-into"></template>
`;
